<template>
  <div class="stepModal position-relative">
    <div id="actionModal" aria-labelledby="actionModal" class="modal fade" role="dialog" tabindex="-1">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fw-600">{{ title }}</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div v-if="action=== 'adjustResource'">
              <form class="form-horizontal">
                <div class="row">
                  <label class="col-md-1 col-form-label">CPU</label>
                  <div class="col-md-11">
                    <div class="form-group">
                      <input v-model="form.cpu" class="form-control"
                             placeholder="Enter CPU Core" required type="number">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <label class="col-md-1 col-form-label">RAM (GB)</label>
                  <div class="col-md-11">
                    <div class="form-group">
                      <input v-model="form.ram" class="form-control" placeholder="Enter RAM in GB" required
                             type="number">
                    </div>
                  </div>
                </div>
              </form>

            </div>
            <div v-if="action=== 'upgrade'">
              <form class="form-horizontal">
                <div class="row">
                  <label class="col-md-1 col-form-label">Profile</label>
                  <div class="col-md-11">
                    <div class="form-group">
                      <select v-model="form.profile" class="form-control">
                        <option disabled value="">Select</option>
                        <option value="wpo-starter">WPO Starter</option>
                        <option value="wpo-pro">WPO Professional</option>
                        <option value="wpo-business">WPO Business</option>
                        <option value="mwp-essential75">Essential 75</option>
                        <option value="mwp-essential125">Essential 125</option>
                        <option value="mwp-essential200">Essential 200</option>
                        <option value="mwp-essential300">Essential 300</option>
                        <option value="mwp-core500">Core 500</option>
                        <option value="mwp-core1000">Core 1000</option>
                      </select>
                    </div>
                  </div>
                </div>
              </form>

            </div>
            <div v-if="action=== 'resize'">
              <form class="form-horizontal">
                <div class="row">
                  <label class="col-md-1 col-form-label">Disk (GB)</label>
                  <div class="col-md-11">
                    <div class="form-group">
                      <input v-model="form.disk" class="form-control"
                             placeholder="Enter Disk" required type="number">
                    </div>
                  </div>
                </div>
              </form>

            </div>
            <div v-if="action=== 'nodeGroup'">
              <form class="form-horizontal">
                <div class="row">
                  <label class="col-md-3 col-form-label">Current Node Group</label>
                  <div class="col-md-9">
                    <div class="form-group">
                      <input :value="currentNodeGroupLabel" class="form-control"
                             readonly type="text">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <label class="col-md-3 col-form-label">Select Node Group</label>
                  <div class="col-md-9">
                    <div class="form-group">
                      <select v-model="form.nodeGroup" class="form-control">
                        <option disabled value="">Select Node Group</option>
                        <option v-for="group in availableNodeGroupOptions"
                                :key="group.value"
                                :value="group.value">
                          {{ group.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" data-dismiss="modal" type="button">Close</button>
            <button :disabled="loading" class="btn btn-primary" type="button" @click="submit">
              <i v-if="loading"
                 class="fa fa-spin fa-spinner mr-10"></i>Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "actionModal",
  data() {
    return {
      title: '',
      form: {},
      action: '',
      loading: false,
      currentNodeGroup: '',
      nodeGroupOptions: [
        {label: 'Performance', value: 'performance'},
        {label: 'Standard', value: 'standard'},
      ],
    }
  },
  computed: {
    modifiedNodes() {

    },
    currentNodeGroupLabel() {
      if (!this.currentNodeGroup) return '-';
      const match = this.nodeGroupOptions.find(g => g.value === this.currentNodeGroup);
      return match ? match.label : this.currentNodeGroup;
    },
    availableNodeGroupOptions() {
      return this.nodeGroupOptions.filter(g => g.value !== this.currentNodeGroup);
    }
  },
  methods: {
    async load(data) {
      console.log('data', data);
      this.title = data.title;
      this.action = data.action;
      if (data.action === 'nodeGroup') {
        this.currentNodeGroup = data.nodeGroup || '';
        // Reset selection so the user has to pick a different option
        data.nodeGroup = '';
      }
      this.form = data
      $('#actionModal').modal('show');
    },
    async submit() {
      try {
        this.loading = true
        let message = ''
        if (this.action === 'adjustResource') {
          const resp = await this.$http.post('/lxd/instance/action', {
            grant_type: 'token',
            action: this.action,
            cluster: this.form.cluster,
            name: this.form.name,
            data: {
              ram: `${this.form.ram}${this.form.ramUnit}`,
              cpu: this.form.cpu
            }
          })
          console.log('resp', resp.data)
          message = 'You have successfully adjusted resource.'
        } else if (this.action === 'upgrade') {
          const resp = await this.$http.post('/lxd/instance/action', {
            grant_type: 'token',
            action: this.action,
            cluster: this.form.cluster,
            name: this.form.name,
            data: {
              profile: this.form.profile
            }
          })
          console.log('resp', resp.data)
          message = 'You have successfully upgraded instance.'
        } else if (this.action === 'resize') {
          const resp = await this.$http.post('/lxd/instance/action', {
            grant_type: 'token',
            action: this.action,
            cluster: this.form.cluster,
            name: this.form.name,
            data: {
              size: this.form.disk
            }
          })
          console.log('resp', resp.data)
          message = 'You have successfully upgraded instance.'
        } else if (this.action === 'nodeGroup') {
          const resp = await this.$http.post('/lxd/instance/action', {
            grant_type: 'token',
            action: this.action,
            cluster: this.form.cluster,
            name: this.form.name,
            data: {
              node_group: this.form.nodeGroup,
              action: 'start',
              instance: this.form.name,
            }
          })
          console.log('resp', resp.data)
          message = 'You have successfully updated node group.'
        }
        await this.$emit('refresh')
        this.showToast({
          message,
          duration: 2000
        }, true, 'success')
        $('#actionModal').modal('hide');

      } catch (e) {
        console.log('error occurred', e);
        this.showToast({
          message: `Something went wrong! ${e.toString()}`,
          duration: 2000
        }, true, 'danger')
      } finally {
        this.loading = false
      }


    },

  }
}
</script>

<style scoped>

</style>
